import React from "react";
import { Route, NavLink } from "react-router-dom";

import { Wallet3 } from '../../Components/Account/Wallet3.jsx';
import { AccountLinkovi } from '../../Components/Account/AccountLinkovi.jsx';

export class UserWalletDashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: props.initialActiveTab || 'casino',
            hideAmount: false
        };
    }
    componentDidMount() {
        casino.repos.sessionRepo.get()
            .then((sesija) => {
                this.props.updateUserFn(sesija.igrac, sesija.sesijaId);

            })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.novcanikTab !== this.props.novcanikTab) {
            this.setState({
                activeTab: this.props.novcanikTab,
            });
        }
    }


    formatCurrency(amount) {
        return casino.utils.numberWithCurrencyFromated(amount, this.props.user.valuta);
    }

    renderTotalAmount() {
        return !this.state.hideAmount ? this.formatCurrency(this.props.user.ukupnoRaspolozivo) : "****";
    }

    renderAvaiableToWithdraw() {
        return this.formatCurrency(this.props.user.casinoRaspolozivoZaIsplatu + this.props.user.sportRaspolozivoZaIsplatu);
    }

    ChevronRightIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
    );

    removeGameFrame() {
        const gameFrame = document.getElementById("gameFrame");
        if (gameFrame) {
            const clone = gameFrame.cloneNode(true);
            gameFrame.parentNode.replaceChild(clone, gameFrame);
        }
    }

    handleLinkClick = (href) => (e) => {
        if (!this.props.pathName) {
            e.preventDefault();
            this.removeGameFrame();
            window.location.href = href;
        }
    }

    renderWalletItem({ icon, label, value, href, to, showArrow = false, arrowClass = "" }) {
        const content = (
            <>
                <span className="wd-icon">
                    <span className={`wd-icon-base ${icon}`} />
                </span>
                <span className="wd-label">{label}</span>
                {value !== undefined && <span className="wd-value">{value}</span>}
                {showArrow && <span className={`wd-arrow${arrowClass ? ' ' + arrowClass : ''}`}>{this.ChevronRightIcon()}</span>}
            </>
        );

        if (to && this.props.pathName) {
            return <li className="wd-list-item"><NavLink to={to}>{content}</NavLink></li>;
        }
        if (to && !this.props.pathName) {
            return <li className="wd-list-item"><a href={to} onClick={this.handleLinkClick(to)}>{content}</a></li>;
        }
        if (href) {
            return <li className="wd-list-item"><a href={href} target="_top" onClick={this.handleLinkClick(href)} className={this.props.simple ? "wd-withdrawal-link" : undefined}>{content}</a></li>;
        }
        return <li className="wd-list-item">{content}</li>;
    }

    getCasinoLink(routePath, desktopPath) {
        const { simple, fromSport, isMobile, getHomePathFn, route } = this.props;
        if (simple) {
            return { href: `https://mcasino.supersport.hr${routePath}&simple=1` };
        }
        if (fromSport) {
            return { href: isMobile ? `https://mcasino.supersport.hr${routePath}` : `https://casino.supersport.hr${desktopPath}` };
        }
        if (route && getHomePathFn) {
            return { to: getHomePathFn(route.location, routePath) };
        }
        return { href: `https://mcasino.supersport.hr${routePath}` };
    }

    renderSportTab(isFromWidget) {
        const { simple, user } = this.props;
        const simpleSuffix = simple ? "&simple=1" : "";

        return (
            <div id="sport" className="wd-wallet-content wd-anim-tab-content">
                <ul className="wd-wallet-list">
                    {this.renderWalletItem({ icon: "wd-available-for-play", label: "Raspoloživo za igru", value: this.formatCurrency(user.sportRaspolozivo) })}
                    {this.renderWalletItem({ icon: "wd-available-for-withdrawal", label: "Raspoloživo za isplatu", value: this.formatCurrency(user.sportRaspolozivoZaIsplatu) })}
                    {!isFromWidget && this.renderWalletItem({ icon: "wd-bonuses", label: "Sport bonusi", value: "0,00 €", href: `https://m.supersport.hr/racun#/bonusi${simpleSuffix}`, showArrow: true, arrowClass: "ml" })}
                    {!isFromWidget && this.renderWalletItem({ icon: "wd-transaction-history", label: "Pregled transakcija", href: `https://m.supersport.hr/racun#/transakcije${simpleSuffix}`, showArrow: true })}
                    {!isFromWidget && this.renderWalletItem({ icon: "wd-withdraw-money", label: "Isplata",  showArrow: true })}
                </ul>
            </div>
        );
    }

    renderCasinoTab(isFromWidget) {
        const { simple, user } = this.props;

        return (
            <div id="casino" className="wd-wallet-content wd-anim-tab-content">
                <ul className="wd-wallet-list">
                    {this.renderWalletItem({ icon: "wd-available-for-play", label: "Raspoloživo za igru", value: this.formatCurrency(user.casinoRaspolozivo) })}
                    {this.renderWalletItem({ icon: "wd-available-for-withdrawal", label: "Raspoloživo za isplatu", value: this.formatCurrency(user.casinoRaspolozivoZaIsplatu) })}
                    {!isFromWidget && this.renderWalletItem({
                        icon: "wd-bonuses", label: "Casino bonusi",
                        value: this.formatCurrency(user.casinoPrewagerBonusIznos),
                        showArrow: true, arrowClass: "ml",
                        ...this.getCasinoLink('/account/bonuses', '/racun/bonusi')
                    })}
                    {!isFromWidget && this.renderWalletItem({
                        icon: "wd-transaction-history", label: "Pregled transakcija",
                        showArrow: true, arrowClass: simple ? "ml" : "",
                        ...this.getCasinoLink('/account/transactions', '/racun/transakcije')
                    })}
                    {!isFromWidget && this.renderWalletItem({
                        icon: "wd-played-games", label: "Odigrane igre",
                        showArrow: true, arrowClass: simple ? "ml" : "",
                        ...this.getCasinoLink('/account/games', '/racun/OdigraneIgre')
                    })}
                    {!isFromWidget && this.renderWalletItem({
                        icon: "wd-played-games", label: "Odigrane besplatne igre",
                        showArrow: true, arrowClass: simple ? "ml" : "",
                        ...this.getCasinoLink('/account/free-games', '/racun/OdigraneBesplatneIgre')
                    })}
                    {!isFromWidget && this.renderWalletItem({
                        icon: "wd-withdraw-money", label: "Isplata",
                        showArrow: true,
                        href: `https://m.supersport.hr/racun#/isplata${simple ? '?simple=1' : ''}`
                    })}
                </ul>
            </div>
        );
    }

    render() {
        const { activeTab, hideAmount } = this.state;
        const { user, simple, fromSport, pathName, onLogout, fetchDataFn } = this.props;

        return (
            <div className="wd-wallet-container-wrapper">
                <div className="wd-wallet-container">
                    <header className="wd-header wd-anim wd-anim-slide-up">
                        <span className="wd-username">{user.nadimak}</span>
                        <button className="wd-deposit-btn">
                            <span className="wd-deposit-icon"></span>
                            <a href={casino.config.urls.uplata + (simple ? "&simple=1" : "")} target="_top" onClick={this.handleLinkClick(casino.config.urls.uplata + (simple ? "&simple=1" : ""))}>UPLATI</a>
                        </button>
                    </header>

                    <div className="wd-balance-card wd-anim wd-anim-fade wd-anim-delay-1">
                        <div className="wd-balance-main">
                            <div className="wd-balance-info">
                                <h3>Ukupno raspoloživo za igru</h3>
                                <p className="wd-amount">{this.renderTotalAmount()}</p>
                            </div>
                        </div>
                        <a href={`https://m.supersport.hr/racun#/isplata${simple ? "&simple=1" : ""}`} target="_top" className="wd-withdrawal-link" onClick={this.handleLinkClick(`https://m.supersport.hr/racun#/isplata${simple ? "&simple=1" : ""}`)}>
                            <span>Ukupno raspoloživo za isplatu</span>
                            <span className="wd-amount">{this.renderAvaiableToWithdraw()}  {this.ChevronRightIcon()} </span>
                        </a>
                        <span className={!hideAmount ? "wd-icon-eye" : "wd-icon-hidden"} onClick={() => this.setState({ hideAmount: !hideAmount })}></span>
                    </div>

                    <Wallet3 {...this.props} key="wallet3" simple={simple} fetchDataFn={fetchDataFn} />

                    <h2 className="wd-section-heading wd-anim wd-anim-slide-down wd-anim-delay-3">Moj novčanik</h2>

                    <div className="wd-tabs wd-anim wd-anim-slide-down wd-anim-delay-4">
                        <button
                            className={`wd-tab-button ${activeTab === 'sport' ? 'wd-active' : ''}`}
                            onClick={() => {
                                this.setState({ activeTab: 'sport' });
                                this.props.onNovcanikTabChange?.('sport');
                            }}
                        >
                            SPORT
                        </button>
                        <button
                            className={`wd-tab-button ${activeTab === 'casino' ? 'wd-active' : ''}`}
                            onClick={() => {
                                this.setState({ activeTab: 'casino' });
                                this.props.onNovcanikTabChange?.('casino');
                            }}
                        >
                            CASINO I POKER
                        </button>
                    </div>

                    {activeTab === 'sport' && this.renderSportTab(this.props.isFromWidget)}
                    {activeTab === 'casino' && this.renderCasinoTab(this.props.isFromWidget)}

                    {!fromSport && pathName && (
                        <div className="wd-other-section wd-anim wd-anim-slide-down wd-anim-delay-6">
                            <h2 className="wd-section-heading">Ostalo</h2>
                            <Route exact path={pathName} render={() =>
                                (<AccountLinkovi key="linkovi" {...this.props} path={pathName} />)} />
                            <hr />
                            <button className="link link-20 red" onClick={() => onLogout(true)}>
                                Odjavi me
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
